import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import DetailModal from "./Detail/DetailModal";
import ReturnModal from "./ReturnModal";
import {
  resourcesSalidas,
  activeBranch,
  duplicateBranch,
  resourcesOperators,
  resourcesBranch,
  resourcesUnits,
  getSalidasFilters,
  deleteSalidasAll,
  getRouteConfigs,
} from "../../helpers/backend_helper";
import {
  DestroyAlertHelper,
  Alert,
  ConfirmAlertHelper,
} from "../../helpers/alerts/alertHelper";
import { getStorageUser } from "../../helpers/api_helper";
import { Container, Input, InputGroup, InputGroupText, Row } from "reactstrap";
import PeriodFilterHelper from "../../helpers/PeriodFilterHelper";
import ButtonHelper from "../../helpers/ButtonHelper";
import dayjs from "dayjs";

import Select from "react-select";
import PreviewPDF from "../../helpers/previewPDF";
import ImportModal from "./ImportModal";
import { findValue } from "../Catalogs/ConfigurationRoute/ConfigurationRoute";
import { ROUTES_CONFIGS } from "../../constants/routeConfigs";
import { createFilter } from "react-select/dist/react-select.cjs.prod";
import AccessaModal from "./AccessaModal";

const Salidas = () => {
  document.title = "Salidas | Sistema de Logística";
  let timeElapsed = new Date();
  let dateNow = dayjs().format("YYYY-MM-DD");
  const [date, setDate] = useState({ initDate: dateNow, endDate: dateNow });
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalPdf, setModalPdf] = useState({ show: false });
  const [modalDetail, setModalDetail] = useState({ show: false, id: null });
  const [modalImport, setModalImport] = useState({ show: false, id: null });
  const [modalAccessa, setModalAccessa] = useState({ show: false, id: null });
  const [modalReturn, setModalReturn] = useState({
    show: false,
    id: null,
    item: null,
  });
  const [selects, setSelects] = useState({
    operadores: [],
    operator: null,
    units: [],
    unit: null,
    ramales: [],
    ramal: null,
  });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "date",
    order: "desc",
    companySession: authUser.company_id,
    initDate: dayjs().startOf("day").toDate(),
    endDate: dayjs().endOf("day").toDate(),
    unit_id: null,
    ramal_id: null,
  });

  const [items, setItems] = useState([]);
  const itemBase = {
    id: null,
    ramal_id: null,
    timer: 1,
    type: 1,
    date: dateNow,
    time: "",
    operator_id: null,
    unit_id: null,
    destination: "",
    route_id: authUser.route_id,
  };
  const [item, setItem] = useState(itemBase);

  const [minutesToEditConfig, setMinutesToEditConfig] = useState();
  const [minutesToDeleteConfig, setMinutesToDeleteConfig] = useState();

  const today = dayjs().startOf("day");

  const getSalidas = async (params,) => {
    const response = await resourcesSalidas("get", params);
    setItems(response.data ?? []);
    setDataPag(response.meta ?? { total: 0 });
    setPending(false);
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    let params = {
      params: {
        ...filters,
        initDate: dayjs(filters.initDate).format("YYYY-MM-DD HH:mm"),
        endDate: dayjs(filters.endDate).format("YYYY-MM-DD HH:mm"),
      },
      signal
    };
    if (localStorage.getItem("config")) {
      console.log(JSON.parse(localStorage.getItem("config")));
      setFilters({
        ...filters,
        initDate: dayjs(
          `${JSON.parse(localStorage.getItem("config")).initDate}`
        ).toDate(),
        endDate: dayjs(
          `${JSON.parse(localStorage.getItem("config")).endDate}`
        ).endOf('day').toDate(),
        unit_id: JSON.parse(localStorage.getItem("config")).unit_id,
        ramal_id: JSON.parse(localStorage.getItem("config")).ramal_id,
        operador_id: JSON.parse(localStorage.getItem("config")).operator_id,
      });
      localStorage.removeItem("config");
    }
    setPending(true);
    getSalidas(params);

    return () => {
      controller.abort();
    };
  }, [filters]);

  const fetchConfigs = async () => {
    const resource = await getRouteConfigs();

    const minutesToEdit = findValue(resource, ROUTES_CONFIGS.MINUTES_TO_EDIT);
    const minutesToDelete = findValue(
      resource,
      ROUTES_CONFIGS.MINUTES_TO_DELETE
    );

    setMinutesToEditConfig(minutesToEdit);
    setMinutesToDeleteConfig(minutesToDelete);
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  const addUpd = (row = false) => {
    if (row.id) {
      setItem(row);
      setModal({ ...modal, show: true, update: true });
    } else {
      setItem({ ...itemBase });
      setModal({ ...modal, show: true, update: false });
    }
  };

  const destroy = async (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      const response = await resourcesSalidas("del", id, id);
      Alert(response.message, response.status);
      if (response.status) {
        setItems(items.filter((i) => i.id != id));
      }
    });
  };

  const destroyAll = async (id) => {
    ConfirmAlertHelper(
      async (confirmed) => {
        if (!confirmed) {
          return;
        }
        const response = await deleteSalidasAll(
          dayjs(filters.initDate).format("YYYY-MM-DD")
        );
        if (response.status) {
          setItems([]);
        }
      },
      "Eliminar",
      "¿Está seguro que deseas eliminar todas las salidas del día " +
      dayjs(filters.initDate).format("DD/MM/YYYY") +
      "?"
    );
  };

  useEffect(() => {
    const getSelects = async () => {
      let params = { params: { select: true } };
      const response = await getSalidasFilters();

      setSelects({
        ...selects,
        operadores: response.operators ?? [],
        ramales: response.branches ?? [],
        units: response.units ?? [],
      });
    };
    getSelects();
  }, []);

  const updateList = () => {
    setFilters({ ...filters });
  };

  const getReports = async (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    const exportSalidas = await resourcesSalidas("get", config);
    if (type == 1) {
      const url = URL.createObjectURL(new Blob([exportSalidas]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Salidas.xlsx");
      document.body.appendChild(link);
      link.click();
    } else {
      let nombre = "Archivo";
      var reader = new FileReader();
      reader.readAsDataURL(exportSalidas);
      reader.fileName = nombre[1] || nombre[0];
      reader.onloadend = function (name) {
        name = nombre[0];
        var base64data = reader.result;
        setModalPdf({ show: true, update: false, url: base64data });
      };
    }
  };

  const columns = Columns(
    addUpd,
    destroy,
    items,
    setItems,
    duplicateBranch,
    authUser,
    setModalDetail,
    modalDetail,
    setModalReturn,
    modalReturn,
    minutesToEditConfig,
    minutesToDeleteConfig,
    modalAccessa,
    setModalAccessa
  );
  document.title = "Salidas";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Salidas"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
              filterInp={false}
            >
              <div className="mb-3">
                <ButtonHelper
                  actionSave={addUpd}
                  addButon={![4].includes(authUser.profile_id)}
                  reportButons={![4].includes(authUser.profile_id)}
                  actionReportButon={getReports}
                  actionAddButon={addUpd}
                  importButtons={![4].includes(authUser.profile_id)}
                  actionImportButton1={() => {
                    setModalImport({ ...modalImport, show: true });
                  }}
                >
                  <>
                    {[3].includes(authUser.profile_id) && (
                      <button
                        className="btn btn-sm btn-danger float-end me-2"
                        onClick={() => destroyAll()}
                      >
                        <i className="fas fa-solid fa-times"></i> Eliminar
                        salidas
                      </button>
                    )}
                  </>
                </ButtonHelper>
              </div>
              <Row>
                <PeriodFilterHelper
                  setFilters={setFilters}
                  filters={filters}
                  initTime={true}
                  endTime={true}
                  modal={modalPdf}
                  setModal={setModalPdf}
                />
                <div className="col-sm-2">
                  <label className="form-label">Unidades:</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    defaultValue={
                      JSON.parse(localStorage.getItem("config"))?.unit
                        ? JSON.parse(localStorage.getItem("config")).unit
                        : selects.unit
                    }
                    isSearchable={true}
                    filterOption={createFilter({
                      matchFrom: "any",
                      stringify: (option) => `${option.label}`,
                    })}
                    name="unit"
                    placeholder="Unidades"
                    options={selects.units}
                    getOptionLabel={(option) => `${option.number}`}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={(e) => [
                      setSelects({ ...selects, unit: e }),
                      setFilters({ ...filters, unit_id: e ? e.id : null }),
                    ]}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="form-label">Ramales:</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    defaultValue={
                      JSON.parse(localStorage.getItem("config"))?.ramal
                        ? JSON.parse(localStorage.getItem("config")).ramal
                        : selects.ramal
                    }
                    isSearchable={true}
                    filterOption={createFilter({
                      stringify: (option) => `${option.label}`,
                    })}
                    name="unit"
                    placeholder="Ramales"
                    options={selects.ramales}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={(e) => [
                      setSelects({ ...selects, ramal: e }),
                      setFilters({ ...filters, ramal_id: e ? e.id : null }),
                    ]}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="form-label">Operador:</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    defaultValue={
                      JSON.parse(localStorage.getItem("config"))?.operator
                        ? JSON.parse(localStorage.getItem("config")).operator
                        : selects.operador
                    }
                    isSearchable={true}
                    filterOption={createFilter({
                      stringify: (option) => `${option.label}`,
                    })}
                    name="unit"
                    placeholder="Operadores"
                    options={selects.operadores}
                    getOptionLabel={(option) => option.full_name}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={(e) => [
                      setSelects({ ...selects, operador: e }),
                      setFilters({ ...filters, operador_id: e ? e.id : null }),
                    ]}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="form-label">Búsqueda:</label>
                  <InputGroup>
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Busqueda..."
                      aria-describedby="basic-addon2"
                      value={filters.search}
                      onChange={(e) =>
                        setFilters({ ...filters, search: e.target.value })
                      }
                    />
                    <InputGroupText
                      onClick={() => setFilters({ ...filters, search: "" })}
                    >
                      X
                    </InputGroupText>
                  </InputGroup>
                </div>
              </Row>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
            catalogs={selects}
            minutesToEditConfig={minutesToEditConfig}
          />
        )}
        {modalDetail.show && (
          <DetailModal
            modal={modalDetail}
            setModal={setModalDetail}
            authUser={authUser}
            setItems={setItems}
            items={items}
            setModalPdf={setModalPdf}
            reloadData={() => {
              let params = {
                params: {
                  ...filters,
                  initDate: dayjs(filters.initDate).format("YYYY-MM-DD HH:mm"),
                  endDate: dayjs(filters.endDate).format("YYYY-MM-DD HH:mm"),
                },
              };
              getSalidas(params);
            }}
          />
        )}
        {modalReturn.show && (
          <ReturnModal
            modal={modalReturn}
            setModal={setModalReturn}
            authUser={authUser}
          />
        )}
        {modalImport.show && (
          <ImportModal
            modal={modalImport}
            setModal={setModalImport}
            onComplete={() => {
              updateList();
            }}
          />
        )}
        {modalPdf.show && (
          <PreviewPDF
            title="Ticket"
            modalPdf={modalPdf}
            setModalPdf={setModalPdf}
          />
        )}

        {modalAccessa.show && (
          <AccessaModal
            modal={modalAccessa}
            setModal={setModalAccessa}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Salidas;
